import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('streamToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

class SwitcherService {
  static async access() {
    try {
      const { data } = await api.get('/switcher/access');
      return !!data.allowed;
    } catch { return false; }
  }
  // Streams usable as an input: the caller's own + any team member's.
  static async sources() {
    const { data } = await api.get('/switcher/sources');
    return data.data || [];
  }
  static async list() {
    const { data } = await api.get('/switcher');
    return data.data || [];
  }
  static async create(name) {
    const { data } = await api.post('/switcher', { name });
    return data.data;
  }
  static async get(id) {
    const { data } = await api.get(`/switcher/${id}`);
    return data.data;
  }
  static async update(id, payload) {
    const { data } = await api.put(`/switcher/${id}`, payload);
    return data.data;
  }
  static async remove(id) {
    await api.delete(`/switcher/${id}`);
  }
  static async setInput(id, slot, stream_id, label) {
    const { data } = await api.put(`/switcher/${id}/inputs/${slot}`, { stream_id, label });
    return data.data;
  }
  static async removeInput(id, slot) {
    const { data } = await api.delete(`/switcher/${id}/inputs/${slot}`);
    return data.data;
  }
  static async start(id) {
    const { data } = await api.post(`/switcher/${id}/start`);
    return data.data;
  }
  static async stop(id) {
    const { data } = await api.post(`/switcher/${id}/stop`);
    return data.data;
  }
  static async take(id, slot) {
    const { data } = await api.post(`/switcher/${id}/take`, { slot });
    return data;
  }
  // The owner's own regular streams eligible as a "push live to main" target.
  static async pushTargets(id) {
    const { data } = await api.get(`/switcher/${id}/push-targets`);
    return data.data || [];
  }
  static async pushToMain(id, streamId) {
    const { data } = await api.post(`/switcher/${id}/push-to-main`, { stream_id: streamId });
    return data;
  }
  static async stopPushToMain(id) {
    const { data } = await api.post(`/switcher/${id}/push-to-main/stop`);
    return data;
  }
}

export default SwitcherService;
